import * as React from "react";
import { Select } from "antd";
declare module "antd/lib/select" {
  export interface SelectProps {
    label?: string;
  }
}
declare module "antd/lib/select" {
  export interface OptionProps {
    label?: React.ReactNode;
  }
}

const { Option } = Select;
export interface State {}

export interface Props {
  onChange?: any;
  onSearch?: any;
  onSelect?: any;
  onFocus?: any;
  placeholder?: string | React.ReactNode;
  value?: string;
  allowClear?: boolean;
  showSearch?: boolean;
  notFoundContent?: string;
  key?: any;
  label?: any;
  style?: React.CSSProperties;
  loading?: boolean;
  optionFilterProp?: string;
  selectOptions: any;
  selectOptionKey: any;
  selectOptionValue: any;
  clearIcon?: any;
  defaultActiveFirstOption?: boolean;
  disabled?: boolean;
  mode?: any;
  size?: "default" | "large" | "small";
}
export interface OptionProps {
  disabled?: boolean;
  value?: string | number;
  title?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  label?: string | number;
}

export default class SelectInput extends React.Component<Props, State> {
  static Option: React.ClassicComponentClass<OptionProps>;
  render() {
    const {
      showSearch,
      onChange,
      onSearch,
      onSelect,
      onFocus,
      placeholder,
      allowClear,
      notFoundContent,
      key,
      label,
      style,
      loading,
      optionFilterProp = "label",
      selectOptionKey,
      selectOptionValue,
      selectOptions,
      clearIcon,
      value,
      defaultActiveFirstOption,
      disabled,
      mode,
      size
    } = this.props;

    return (
      <Select
        onSearch={onSearch}
        onSelect={onSelect}
        onFocus={onFocus}
        placeholder={placeholder}
        value={value}
        allowClear={allowClear}
        notFoundContent={notFoundContent}
        key={key}
        label={label}
        style={style}
        loading={loading}
        optionFilterProp={optionFilterProp}
        showSearch={showSearch}
        onChange={onChange}
        clearIcon={clearIcon}
        defaultActiveFirstOption={defaultActiveFirstOption}
        disabled={disabled}
        mode={mode}
        size={size}
      >
        {selectOptions?.map((item) => (
          <Option
            key={item[selectOptionKey]}
            label={item[selectOptionValue]}
            title={""}
          >
            {item[selectOptionValue]}
          </Option>
        ))}
      </Select>
    );
  }
}
